var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SettingsComponent',{attrs:{"refLink":"https://vk.com/app51805704"}})
}
var staticRenderFns = []

export { render, staticRenderFns }